import { connect } from 'react-redux'
import requestAddCard from '../../sagas/requestAddCard'
import CreateCard from './CreateCard'

export default connect(
  (state, props) => {
    return {
      name: state['view-board'].cards[props.cardId].name
    }
  },
  {
    requestAddCard,
  }
)(CreateCard)
